<template>
  <div>
    <!-- 重要なお知らせ -->
    <header-notice v-show="notice.display" :message="notice.message" :type="notice.type" />
    <!-- ヘッダーエリア -->
    <header class="l-header">
      <!-- ヘッダーコンテンツ: ロゴ -->
      <header-logo :header-data="headerData" />

      <!-- ヘッダーコンテンツ: サイト名,サイト選択 -->
      <header-site ref="headerSite" :header-data="headerData" @open="headerSiteOpen()" />

      <div class="l-header-functions">

        <!-- ヘッダーコンテンツ: ツールチップ -->
        <!-- <header-tooltip></header-tooltip> -->

        <!-- ヘッダーコンテンツ: お知らせ -->
        <header-info ref="headerInfo" :header-data="headerData" @open="headerInfoOpen()" />

        <!-- ヘッダーコンテンツ: アカウント名 -->
        <header-config ref="headerConfig" :header-data="headerData" @open="headerConfigOpen()" />

      </div>
    </header>
  </div>
  <!-- /ヘッダーエリア -->
</template>


<script>
import store from '../../funcs/store.js';
export default {
  props: {
    headerData: Object,
  },
  data: function () {
    return {
      notifications: null,
      notice: {
        display: false,
        type: 'info',
        message: ''
      }
    }
  },
  created : function() {
    store.setSystemAdmin(this.headerData.isSystemAdmin);
    store.setSystemAdminEdit(this.headerData.isSystemAdminEdit);
    store.setSiteAdmin(this.headerData.isSiteAdmin);
    store.selecteServiceId(this.headerData.selectedServiceId);
    store.setServiceTypes(this.headerData.serviceTypes);
    store.setUseAbTest(this.headerData.canUseAbTest);
    store.setUseTrackingTag(this.headerData.useTrackingTag);
    store.setUseTargetReachCount(this.headerData.canUseTargetReachCount);
    store.setUseDeliveryCalendar(this.headerData.useDeliveryCalendar);
    store.setUseReminder(this.headerData.useReminder);
    store.setResourceAccessRules(this.headerData.resourceAccessRules);

    if (this.headerData.notice) {
      this.notice = this.headerData.notice;
    }
  },
  methods: {
    headerInfoOpen(){
      this.$refs.headerConfig.close();
      this.$refs.headerSite.close();
    },
    headerConfigOpen(){
      this.$refs.headerInfo.close();
      this.$refs.headerSite.close();
    },
    headerSiteOpen(){
      this.$refs.headerConfig.close();
      this.$refs.headerInfo.close();
    },
  }
};
</script>
